'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _zarm = require('zarm');

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _fetch = require('../../utils/fetch');

var _fetch2 = _interopRequireDefault(_fetch);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AntiBrush = function (_PureComponent) {
  _inherits(AntiBrush, _PureComponent);

  function AntiBrush(props) {
    _classCallCheck(this, AntiBrush);

    var _this = _possibleConstructorReturn(this, (AntiBrush.__proto__ || Object.getPrototypeOf(AntiBrush)).call(this, props));

    _this.onClose = function () {
      var onClose = _this.props.onClose;


      _this.setState({
        ivcURL: ''
      });

      onClose();
    };

    _this.getIvcURL = function () {
      var sTokenId = _this.props.sTokenId;

      var ivcURL = _config2.default.API.api.host + '/facilities/open/v1/common/security/ivc?sTokenId=' + sTokenId + '&t=' + new Date().getTime();

      _this.setState({
        ivcURL: ivcURL
      });
    };

    _this.verifyAntiIvc = function () {
      var _this$props = _this.props,
          sTokenId = _this$props.sTokenId,
          onSuccess = _this$props.onSuccess,
          onClose = _this$props.onClose;
      var imgCode = _this.state.imgCode;
      var data = _this.props.data;


      if (!imgCode) {
        _this.setState({
          ivcRrror: '请输入图形验证码'
        });
        return false;
      }

      _this.setState({ ivcRrror: '' });

      _fetch2.default.fetch({
        path: '/facilities/open/v1/common/security/ivc/civc',
        server: 'api',
        method: 'GET',
        data: {
          sTokenId: sTokenId,
          imgCode: imgCode
        }
      }).then(function (_ref) {
        var isSuccess = _ref.isSuccess,
            result = _ref.result,
            errorMsg = _ref.errorMsg;

        if (isSuccess && result) {
          onSuccess(result.ticket, data);
        } else {
          _this.setState({ ivcRrror: errorMsg });
        }
      }).catch(function () {
        onClose && onClose();
      });
    };

    _this.state = {
      ivcURL: '',
      imgCode: '',
      ivcRrror: ''
    };

    _this.visible = props.visible;
    return _this;
  }

  _createClass(AntiBrush, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getIvcURL();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ('visible' in nextProps && nextProps.visible !== this.visible) {
        this.visible = nextProps.visible;
        this.getIvcURL();
      }
    }

    // 获取图形URL


    // 验证图形

  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _this2 = this;

      var _state = this.state,
          ivcURL = _state.ivcURL,
          ivcRrror = _state.ivcRrror;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'anti-ivc' },
          _react2.default.createElement(
            'div',
            { className: 'anti-ivc-content' },
            _react2.default.createElement(_zarm.Input, {
              type: 'text',
              placeholder: '\u8BF7\u8F93\u5165\u56FE\u5F62\u9A8C\u8BC1\u7801',
              prefixCls: 'cui-input',
              onChange: function onChange(e) {
                _this2.setState({
                  imgCode: e,
                  ivcRrror: ''
                });
              }
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'anti-ivc-footer', onClick: function onClick() {
                return _this2.getIvcURL();
              } },
            ivcURL ? _react2.default.createElement('img', { src: ivcURL, alt: '' }) : '获取图形验证码'
          )
        ),
        ivcRrror ? _react2.default.createElement(
          'div',
          { className: 'anti-ivc-help' },
          ivcRrror
        ) : null
      );
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      var _this3 = this;

      return _react2.default.createElement(
        _zarm.Button,
        {
          block: true,
          shape: 'radius',
          theme: 'primary',
          size: 'sm',
          prefixCls: 'cui-button',
          onClick: function onClick() {
            return _this3.verifyAntiIvc();
          }
        },
        '\u786E\u8BA4'
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          className = _props.className,
          visible = _props.visible;


      var cls = (0, _classnames3.default)(_defineProperty({
        'ui-anti-brush-modal': true
      }, className, !!className));

      return _react2.default.createElement(
        _zarm.Modal,
        {
          shape: 'radius',
          width: '85%',
          title: '\u9A8C\u8BC1\u7801',
          closable: true,
          maskClosable: true,
          prefixCls: 'cui-modal',
          className: cls,
          visible: visible,
          onCancel: function onCancel() {
            return _this4.onClose();
          },
          footer: this.renderFooter()
        },
        this.renderBody()
      );
    }
  }]);

  return AntiBrush;
}(_react.PureComponent);

AntiBrush.defaultProps = {
  className: '',
  data: '',
  sTokenId: '',
  visible: true,
  onSuccess: function onSuccess() {},
  onClose: function onClose() {}
};
AntiBrush.propTypes = {
  className: _propTypes2.default.string,
  data: _propTypes2.default.string,
  sTokenId: _propTypes2.default.string,
  visible: _propTypes2.default.bool,
  onSuccess: _propTypes2.default.func,
  onClose: _propTypes2.default.func
};
exports.default = AntiBrush;